module.exports = __webpack_public_path__ + "c2h4static/img/link.9db977a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/link.jpg
// module id = iQlR
// module chunks = 1